import { Home } from "lucide-react";
import type { NavSection } from "@skypointcloud/skypoint-ui";
import { PRODUCT_LABELS } from "../../../shared/products/keys";

/**
 * skyPerformance IT's sidebar (spec 2026-10-26 §4.6). Phase 0 draws one item, Home, for anyone
 * holding an IT role; later phases add their pages here. Ids are stable keys the route table and
 * the route guard index on.
 *
 * PURE: no store, no RTK, so the shell (sidebarConfig.ts) can call it and a test can too.
 */
export const PIT_NAV_IDS = {
  PIT_HOME: "pit-home",
} as const;
export type PitNavId = (typeof PIT_NAV_IDS)[keyof typeof PIT_NAV_IDS];

export interface PerformanceItNavContext {
  /** The caller holds a skyPerformance IT role on this instance (the session's productRoles). */
  held: boolean;
}

/** IT's sections, or none for someone without an IT role (the guard then admits no IT page). */
export function buildPerformanceItNavSections(ctx: PerformanceItNavContext): NavSection[] {
  if (!ctx.held) return [];
  return [
    {
      // The product's short label, as the switcher names it (review 03 P2-4).
      header: PRODUCT_LABELS.skyperformance_it,
      items: [{ id: PIT_NAV_IDS.PIT_HOME, label: "Home", icon: Home }],
    },
  ];
}
